























import Vue from 'vue';
import { Fragment } from 'vue-fragment';

export default Vue.extend({
  name: 'Button',
  components: {
    Fragment,
  },
  props: {
    active: Boolean,
    alt: Boolean,
    href: String,
    large: Boolean,
    loading: Boolean,
    minimal: Boolean,
    onClick: {
      type: Function,
      default: () => null,
    },
    target: String,
    type: {
      type: String,
      default: 'button',
    },
  },
});
